import _get from 'lodash/get';
import axios from 'axios';
import { getUrlWithQueryParams } from '../../helpers/globalHelper';
import { getCsrfToken, isLoggedIn } from '../../helpers/twHelper';
import { receivedNNAError, receivedNNASuccess, requestNNA } from '../NNAWidget/NNAWidget-Actions';
import { trackActivityEvent } from '../../helpers/analytics/fptiHelper';
import { updateBNAFPTIhome } from '../../helpers/analytics/homePageAnalytics';

// Constants
export const RECOMMENDED_ARTICLES_REQUESTED = 'RECOMMENDED_ARTICLES_REQUESTED';
export const RECOMMENDED_ARTICLES_SUCCESS = 'RECOMMENDED_ARTICLES_SUCCESS';
export const RECOMMENDED_ARTICLES_ERROR = 'RECOMMENDED_ARTICLES_ERROR';

const RC_SOLUTIONS_API_URL = '/smarthelp/api/recommended-solutions';
const BNAPromptURL = '/smarthelp/prompt-bna';

// Track Prompted BNA
const trackBNAs = (bnaArticles) => {
  if (Array.isArray(bnaArticles) && bnaArticles.length > 0) {
    // PCC/BNA prompt event for each BNA article
    return axios
      .post(BNAPromptURL, {
        _csrf: getCsrfToken(),
        BNAList: JSON.stringify(bnaArticles),
      })
      .catch(() => {});
  }
  return null;
};

// Actions
const requestRecommendedSolutions = () => ({
  type: RECOMMENDED_ARTICLES_REQUESTED,
  payload: undefined,
});

const receivedRecommendedSolutions = (response) =>
  // const recommendedSolutions = _get(response, 'recommendedSolutions');
  // eslint-disable-next-line implicit-arrow-linebreak
  ({
    type: RECOMMENDED_ARTICLES_SUCCESS,
    payload: response,
  });
const receivedRecommendedSolutionsError = () => ({
  type: RECOMMENDED_ARTICLES_ERROR,
});

export const getRecommendedSolutions =
  (queryParams = {}) =>
  (dispatch) => {
    dispatch(requestRecommendedSolutions());
    if (queryParams.nna) {
      dispatch(requestNNA());
    }

    return axios
      .get(getUrlWithQueryParams(RC_SOLUTIONS_API_URL, queryParams))
      .then((response) => {
        const data = response.data;
        const bnaArticles = _get(data, 'recommendedSolutions.bnas', []);

        // Recommended Solutions/Articles Logic
        dispatch(receivedRecommendedSolutions(data));

        // If logged in and has any BNA's - Track them
        if (isLoggedIn()) {
          trackBNAs(bnaArticles);
        }

        // NNA
        if (queryParams.nna) {
          dispatch(receivedNNASuccess(data.nna));
        }
      })
      .catch(() => {
        dispatch(receivedRecommendedSolutionsError());

        // NNA
        if (queryParams.nna) {
          dispatch(receivedNNAError());
        }
      });
  };

export const updateBnaData = (articleInfo) => {
  if (isLoggedIn()) {
    const { bnaListId = '', bnaId = '', intentCode = '' } = articleInfo.channelDetails || {};
    if (bnaListId && bnaId && intentCode) {
      const fptiOptions = {
        ...updateBNAFPTIhome.updateBNAhome,
        ...{
          hpid: bnaId,
        },
      };
      window.localStorage.setItem('isBNA', true);
      trackActivityEvent(fptiOptions);
      return axios
        .post('/smarthelp/update-bna-data', {
          _csrf: getCsrfToken(),
          bnaListId,
          bnaId,
          intentCode,
        })
        .then(() => {
          trackActivityEvent({ ...updateBNAFPTIhome.updateBNASuccesshome, ...{ hpid: bnaId } });
        })
        .catch(() => {
          trackActivityEvent({ ...updateBNAFPTIhome.updateBNAFailurehome, ...{ hpid: bnaId } });
        }); // Catch BNA error for solving unhandle promise reject issue
    }
  }
  return undefined;
};
